import axios, { AxiosInstance, AxiosInterceptorOptions, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import {
  IHttpClient,
  IHttpClientConfig,
  IHttpClientResponse
} from './HttpClient.interface';

export class HttpClient implements IHttpClient {
  private _axiosInstance: AxiosInstance;

  constructor(httpClientConfig: IHttpClientConfig) {
    this._axiosInstance = axios.create(httpClientConfig);
  }

  // To test http calls we need to mock Axios (or anything else under the hood) itself
  // so we need to reveal the implementation details a bit
  // at least for test environment
  get axiosInstance() {
    return this._axiosInstance;
  }

  get<TResponseData = any>(
    url: string,
    config?: IHttpClientConfig
  ): Promise<IHttpClientResponse<TResponseData>> {
    return this._axiosInstance.get(url, config);
  }

  post<TResponseData = any, TRequestData = any>(
    url: string,
    data?: TRequestData,
    config?: IHttpClientConfig
  ): Promise<IHttpClientResponse<TResponseData>> {
    return this._axiosInstance.post(url, data, config);
  }

  put<TResponseData = any, TRequestData = any>(
    url: string,
    data?: TRequestData,
    config?: IHttpClientConfig
  ): Promise<IHttpClientResponse<TResponseData>> {
    return this._axiosInstance.put(url, data, config);
  }

  delete<TResponseData = any>(
    url: string,
    config?: IHttpClientConfig
  ): Promise<IHttpClientResponse<TResponseData>> {
    return this._axiosInstance.delete(url, config);
  }

  // addRequestInterceptor(
  //   onFulfilled: (config: IHttpClientConfig) => IHttpClientConfig | Promise<IHttpClientConfig>,
  //   onRejected?: (error: any) => any,
  //   options?: IHttpClientInterceptorOptions
  // ) {
  //   this._axiosInstance.interceptors.request.use(onFulfilled, onRejected, options);
  // }

  addRequestInterceptor(
    onFulfilled:
    (value: InternalAxiosRequestConfig) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>,
    onRejected?: (error: any) => any,
    options?: AxiosInterceptorOptions
  ) {
    this._axiosInstance.interceptors.request.use(onFulfilled, onRejected, options);
  }

  removeRequestInterceptor(id: number) {
    this._axiosInstance.interceptors.request.eject(id);
  }

  addResponseInterceptor(
    onFulfilled: (config: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>,
    onRejected?: (error: any) => any,
  ) {
    this._axiosInstance.interceptors.response.use(onFulfilled, onRejected);
  }

  removeResponseInterceptor(id: number) {
    this._axiosInstance.interceptors.response.eject(id);
  }
}
